module.exports = __webpack_public_path__ + "media/stylesheets/images/mattrz_lp/img_square-a5c23204fdbdbbdced8ec4991a598823.svg";